module.exports = require("core-js/library/fn/object/keys");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/object/keys.js
// module id = 41
// module chunks = 1 2